import React from 'react';
import { heroContent } from '../data/mock';

const HeroSection = () => {
  return (
    <section className="min-h-[70vh] flex flex-col justify-center px-6 md:px-12 lg:px-24 py-20">
      <div className="max-w-4xl mx-auto text-center">
        <img 
          src="/axis-logo-transparent.png" 
          alt="Axis Affordable ServiceTech Inc. Logo" 
          className="w-32 h-32 md:w-40 md:h-40 mx-auto mb-8 object-contain animate-fade-in"
        />
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-gray-900 tracking-tight mb-6 animate-fade-in">
          {heroContent.headline}
        </h1>
        <p className="text-xl md:text-2xl text-gray-700 font-medium mb-8 leading-relaxed animate-fade-in-delay">
          {heroContent.subheading}
        </p>
        <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto animate-fade-in-delay-2">
          {heroContent.supportingText}
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
